/** Bundled Windows exporter; served from `frontend/public/downloads/`. */
export const ARENA_EXPORTER_DOWNLOAD_HREF = "/downloads/MTGDeckBuilder-ArenaExporter.exe";
export const ARENA_EXPORTER_FILENAME = "MTGDeckBuilder-ArenaExporter.exe";
